"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useCounter;

var _react = require("react");

var _dayjs = _interopRequireDefault(require("dayjs"));

var _digiwashCore = require("digiwash-core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parseMiliseconds(ms = 0) {
  let seconds = Math.floor(ms / 1000 % 60);
  let minutes = Math.floor(ms / (1000 * 60) % 60);
  let hours = Math.floor(ms / (1000 * 60 * 60));
  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;
  return [hours, minutes, seconds];
}

let timeout_id;

function useCounter(input, start) {
  let [desiredDate, setDesiredDate] = (0, _react.useState)(input);
  let [timer, setTimer] = (0, _react.useState)();
  let finalDate = (0, _dayjs.default)(desiredDate).toDate();
  let finalDateInMs = finalDate.getTime();
  let currentTime = Date.now();
  let diff = (0, _dayjs.default)(finalDateInMs).diff((0, _dayjs.default)(currentTime), "milliseconds"); // each seconds we are updating `diff` and showing the result to user

  (0, _react.useEffect)(() => {
    timeout_id = setTimeout(() => {
      if (diff >= 0 && hours < 24) {
        setTimer(diff);
      }
    }, 1000);
    return () => {
      clearTimeout(timeout_id);
    };
  }, [diff]); // in case of updating (component has been mounted already), we restart the timer and set the new date

  (0, _react.useEffect)(() => {
    setTimer(undefined);
    setDesiredDate(input);
  }, [input]); // restart the states when `start` is false

  (0, _react.useEffect)(() => {
    if (!start) {
      setTimer(undefined);
      setDesiredDate(undefined);
      clearTimeout(timeout_id);
    }
  }, [start]);
  let [hours, minutes, seconds] = parseMiliseconds(timer);
  let text;

  if (diff > 0) {
    // if (Platform.OS === "android") {
    text = `${(0, _digiwashCore.formatNumber)((0, _dayjs.default)(desiredDate).fromNow(true))} دیگر`; // }
    // else {
    //   if (hours <= 0 && minutes <= 0 && seconds <= 0) {
    //     text = undefined;
    //   } else if (hours < 24) {
    //     text =
    //       formatNumber(hours) +
    //       ":" +
    //       formatNumber(minutes) +
    //       ":" +
    //       formatNumber(seconds);
    //   } else {
    //     text = `${formatNumber(dayjs(desiredDate).fromNow(true))} دیگر`;
    //   }
    // }
  } else {
    text = "";
  }

  return {
    text
  };
}